import React, { useState, useEffect } from 'react';
import Navbar from "../../components/en/Navbar";
import Footer from "../../components/en/Footer";
import "../../styles/common.css";
import "../../styles/form.css";

const ContactThanks = () => {

  return (
    <>
      <Navbar />
      <main className='contact'>
        <section className='contact form'>
          <h1>Thank you for contacting us.</h1>
          <p className='form-lead'>Thank you for using our website.<br />
            After confirming the details of your inquiry, our representative will contact you.</p>
          <div className='button-content button-arrow button-black'>
            <a href="/">Return to TOP page</a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ContactThanks;
